import { Assessment } from '@/interfaces/assessment';
import { EntityResource } from './entity.resource';

/**
 * Resource ocen
 *
 * @export
 * @class AssessmentResource
 * @extends {EntityResource<Assessment>}
 */
export class AssessmentResource extends EntityResource<Assessment> {
  public getFields = {
    id: true,
    name: true
  };

  public listVariables = { filters: 'AssessmentFilters' };

  public listFields = {
    id: true,
    name: true,
    data: {
      assessments: {
        criterionId: true,
        description: true,
        passed: true,
        value: true
      }
    },
    documentId: true,
    profileId: true,
    profile: {
      id: true,
      firstName: true,
      lastName: true
    }
  };

  constructor() {
    super({
      entityName: 'assessment'
    });
  }
}

export const assessmentResource = new AssessmentResource();
